import { TASK_TYPE } from 'saas/constants';
import { assetAt } from 'utils/assets';

export const pointId = point => `${point.type}_${point.id}`;

export const pointIcon = (point, taskType) => {
  let name;
  if (point.type === 'point' || point.type === 'marker') {
    name = `${taskIcon(taskType)}`;
  } else {
    name = commentIcon(point.icon);
  }

  return assetAt(`images/pins/png/${name}.png`);
};

function taskIcon(task) {
  switch (task.toUpperCase()) {
    case TASK_TYPE.RAT:
      return 'mouse';
    case TASK_TYPE.INSECT:
      return 'insect';
    case TASK_TYPE.DISINFECTION:
      return 'bacteria';
    case TASK_TYPE.OTHER_PESTS:
      return 'pigeon';
    case TASK_TYPE.ANNEX1:
      return 'annex';
    case TASK_TYPE.ANNEX2:
      return 'annex';
    default:
      return null;
  }
}

export const staticIconUrl = icon => assetAt(`images/icons/${icon}.svg`);
export const staticIconUrlPNG = icon => assetAt(`images/icons/${icon}.png`);

function commentIcon(icon) {
  switch (icon.toUpperCase()) {
    case 'INFO':
      return 'information';
    case 'EXCLAMATION':
      return 'exclamation';
    case 'QUESTION':
      return 'interogation';
    case 'CONE':
      return 'works';
    case 'CAMERA':
      return 'camera';
    default:
      return null;
  }
}



// WEBPACK FOOTER //
// ./src/modules/saas/pco/zones/plan/reducers/point.js